<template>
    <div>
        <v-select :multiple="false" :options="optionsMarcas" :placeholder="'Selecciona '+placeholderm"
                  v-model="selectedMarcas" @input="setCambio"></v-select>
    </div>
</template>

<script>
export default {
    name: "marcas",
    props:{
        placeholderm:String,
    },
    data(){
        return{
            selectedMarcas:null,
            optionsMarcas:[],
            fabricante:0
        }
    },
    mounted() {
        //this.getGestores();
    },
    methods:{
        getMarcas(){
            let $this = this;
            axios.post('/api/AdminCatalogos/marcasSelect',{fabricante:this.fabricante})
                .then(r => {
                        $this.optionsMarcas = r.data;
                        //console.log(r);
                    },
                    error => {$this.$toastMessage('error','Error: ' + error +' Por favor envia este error al área de soporte!',9000,'center');}
                );
        },
        setCambio(){
            this.$emit('cambioMarca');
        }
    }
}
</script>

<style scoped>

</style>
